import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import "../../Styles/DashboardStyles.css";
import { screenConfig } from "../../config/screenConfig";
import MemberServices from "../../services/MemberServices";
import AdminUserService from "../../services/adminUserServices";
import * as routeConfig from "../../config/routes";

import {
  IMember,
  resetCreateBody,
  updateMember_Comments,
  updateMember_OtherStateBar,
  updateMember_Sections,
  updateMember_Tags,
  setUpdateEnrollmentStartDate,
  setUpdateEnrollmentEndDate,
  updateMemberPrimaryAddressInfo,
  updateMemberPublishAddressInfo,
} from "../../store/memberApiSlice";

import TextField from "@mui/material/TextField";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
  Label,
  PageLink,
} from "../../components/StyledComp/StyledComp";

import {
  assignCurrentMember,
  initialCurrentMember,
  resetCurrentMember,
} from "../../store/currentMemberSlice";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useForm, Controller } from "react-hook-form";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import ICreateMemberBody, {
  IPaymentInfo,
} from "../../store/memberInterfaceStruct";
import { useNavigate } from "react-router-dom";
import { dateTimePickerTabsClasses } from "@mui/x-date-pickers";
import MDEditSectionMultipleOptionItems from "../../components/MemberDetail/MDEditSectionMultipleOptionItems";
import MDEditTagsMultipleOptionItems from "../../components/MemberDetail/MDEditTagsMultipleOptionItems";
import CreateMemberPersonal from "../../components/CreateMember/CreateMemberPersonal";
import CreateMemberAddress from "../../components/CreateMember/CreateMemberAddress";
import ReactModal from "react-modal";
import {
  initalOrderItem,
  IOrderItem,
  resetOrderParameters,
  setOrderCurrentPage,
  storeAddOrderItem,
  storeUpdateOrder,
  storeUpdateOrderItem,
} from "../../store/orderApiSlice";
import { useAppSelector } from "../../store/hooks";
import OrderServices from "../../services/OrderServices";
import { Paid } from "@mui/icons-material";
import ICurrentMember from "../../store/memberInterfaceStruct";
import InvoiceServices from "../../services/InvoiceServices";
import AlertWithModal from "../../components/utilityComponents/AlertWithModal";
// removed unused aws-sdk import during v2->v3 migration

interface IConfiguration {
  [key: string]: any;
}

interface state {
  [key: string]: any;
}

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
  Status: boolean;
}

interface IMemberTags {
  Fee: number;
  Id: number;
  Description: string;
  MemberTag: string;
  isSelected: boolean;
  Status: boolean;
}

// Comments:
// Get displayed when /create-member url is called

// During create member insert data in  members, member_address, member_section,
// member_tab, member_otherstatebar  tables.

// we will create an entry in orders and membership_order_details table with
// memberCode, selected sections
// orders table will have status Paid, due, partially paid.

// invoice will be generate, member_invoice table will be updated
// promt to email invoice?

// on payment, order_status in order table and isPaid in member_sections table
// will be updated.

//implement cancel order for refund. (low priority)

// for tracking membership due( ie member code payment pending for that FY)
// we will add a field isMembership due in members table.

// we will write a job to update membership due for next FY that will be
// triggerred manually from the front end.

const CreateMemberPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const createMemberBody = useSelector(
    (state: RootState) => state.memberApiSlice
  );
  const [proratedDue, setProratedDue] = useState<number | null>(null);
  const orderInfo = useAppSelector((store) => store.orderapislice);
  const [currentMember, setCurrentMember] =
    useState<ICurrentMember>(initialCurrentMember);

  console.log("currentMember-for noinvoice:", currentMember);
  const [refreshCount, setRefreshCount] = useState(0);
  const [initialRun, setinitialRun] = useState<boolean>(true);

  const [orderItem, setOrderItem] = useState<IOrderItem>({
    ...initalOrderItem,
  });

  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );
  const [firmList, setFirmList] = useState<any[]>([]);
  const [createMemberSuccessFlag, setCreateMemberSuccessFlag] =
    useState<boolean>(false);

  const [createOrderModalOpen, setCreateOrderModalOpen] = useState(false);
  const [paymentInfoModalOpen, setPaymentInfoModalOpen] = useState(false);
  const [viewInvoiceModalOpen, setViewInvoiceModalOpen] = useState(false);
  const [updateEnrollementYearModalOpen, setUpdateEnrollementYearModalOpen] =
    useState(false);

  const [invoiceURL, setinvoiceURL] = useState<string>("");
  const Sections = configurationList.MemberSection;
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [dueAmount, setDueAmount] = useState<number>(0);
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [alertBody, setAlertBody] = useState<string>("");
  const [currentEnrollmentYearStart, setCurrentEnrollmentYearStart] =
    useState<Date>(new Date());
  const [currentEnrollmentYearEnd, setCurrentEnrollmentYearEnd] =
    useState<Date>(new Date());
    const [memberEnrollmentYearStart, setMemberEnrollmentYearStart] =
    useState<Date>(new Date());
    const [memberEnrollmentYearEnd, setMemberEnrollmentYearEnd] =
    useState<Date>(new Date());


  const handleCancel = () => {
    setCreateOrderModalOpen(false);
    console.log("handle Cancel CALLED");
    navigate("/member/findmember", { replace: true });
  };

  const handleCancelViewInvoiceModal = () => {
    setViewInvoiceModalOpen(false);
    navigate("/member/findmember", { replace: true });
  };

  const handleCancelUpdateEnrollementYearModalOpen = () => {
    setUpdateEnrollementYearModalOpen(false);
  };

  const handleSendInvoice = async () => {
    if (
      currentMember.PrimaryAddress &&
      currentMember.PrimaryAddress.Email === null &&
      currentMember.PublishedAddress &&
      currentMember.PublishedAddress.Email === null
    ) {
      alert("Email ID missing");
      return;
    }
    let body = {
      InvoiceLink: invoiceURL,
      FirstName: currentMember.FirstName,
      LastName: currentMember.LastName,
      Esquire: currentMember.Esquire,
      MemberEmail:
        currentMember.PrimaryAddress && currentMember.PrimaryAddress.Email
          ? currentMember.PrimaryAddress.Email
          : currentMember.PublishedAddress &&
            currentMember.PublishedAddress.Email,
    };

    const response = await MemberServices.sendInvoiceEmailToMember(body);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success");
      console.log("response1...", response.data.data);
      alert("Mail Sent Successfully");
      // navigate("/member", { replace: false });
    } else {
      console.log("error", response);
    }
    handleCancelViewInvoiceModal();
  };

  const handleCancelpaymentInfoModal = () => {
    setPaymentInfoModalOpen(false);
  };

  const formCreateMember = useForm<ICreateMemberBody>();
  const {
    register: registerCM,
    control: controlCM,
    handleSubmit: handleSubmitCM,
    formState: formStateCM,
    setValue: setValueCM,
    clearErrors: clearErrorsCM,
  } = formCreateMember;

  const {
    errors: errorsCM,
    touchedFields: touchedFieldsCM,
    dirtyFields: dirtyFieldsCM,
  } = formStateCM;

  const formPaymentInfo = useForm<IPaymentInfo>();
  const {
    register: registerPI,
    control: controlPI,
    handleSubmit: handleSubmitPI,
    formState: formStatePI,
    setValue: setValuePI,
    clearErrors: clearErrorsPI,
  } = formPaymentInfo;

  const {
    errors: errorsPI,
    touchedFields: touchedFieldsPI,
    dirtyFields: dirtyFieldsPI,
  } = formStatePI;

  function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  useEffect(() => {
    dispatch(resetCurrentMember());
    dispatch(resetOrderParameters());
    dispatch(resetCreateBody());
    console.log("selectedItems in useEffect1:", selectedItems);
    const getConfigurationLists = async () => {
      console.log("getConfigurationLists called");

      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
        setMemberTags(response.data.data.MemberTag);
      } else {
      }
    };

    getConfigurationLists();
    getFirmDetailList();

    const initEnrollmentYearValue = () => {
      console.log("inside useEffect");
      const currentDate = new Date(); // Get current date
      const currentYear = currentDate.getFullYear(); // Get current year
      const currentMonth = currentDate.getMonth(); // Get current month (0 for Jan, 11 for Dec)

      // if (currentMonth > 5) {
      //   setCurrentEnrollmentYearStart(new Date(currentYear, 6, 1)); // 1st July of the current year
      //   setCurrentEnrollmentYearEnd(new Date(currentYear + 1, 5, 30)); // 30th June of the next year
      // } else {
      //   setCurrentEnrollmentYearStart(new Date(currentYear - 1, 6, 1)); // 1st July of the previous year
      //   setCurrentEnrollmentYearEnd(new Date(currentYear, 5, 30)); // 30th June of the current year
      // }

      // console.log(currentYear, "=", currentEnrollmentYearEnd.getFullYear());
      // console.log(currentYear, "!=", currentEnrollmentYearStart.getFullYear());
      // // if currentMonth is greater than Feb and less than july
      // i.e second half for current cycle, we show them option
      // to choose current membership year or next membership year
       if (
        currentMonth >= 2 &&
        currentMonth < 6
        // currentEnrollmentYearEnd &&
        // currentYear === currentEnrollmentYearEnd.getFullYear()
      ) {
        console.log("1:");
        setCurrentEnrollmentYearStart(new Date(currentYear - 1, 6, 1)); // 1st July of the current year
        setCurrentEnrollmentYearEnd(new Date(currentYear, 5, 30)); // 30th June of the next year
       // setUpdateEnrollementYearModalOpen(true);
       // return;
      } else  if (
        currentMonth < 2
        // currentEnrollmentYearEnd &&
        // currentYear === currentEnrollmentYearEnd.getFullYear()
      ) {
        console.log("2:");
        // if currentMonth is between jan and Feb in second half of the year
        // we will assume membership is for current membership year.
        // unless there is an active membership; which is not the
        // case in createMember flow.
        setCurrentEnrollmentYearStart(new Date(currentYear - 1, 6, 1)); // 1st July of the current year
        setCurrentEnrollmentYearEnd(new Date(currentYear, 5, 30)); // 30th June of the next year
        dispatch(
          setUpdateEnrollmentStartDate(
            dayjs(new Date(currentYear - 1, 6, 1)).format("YYYY-MM-DD")
          )
        );
        dispatch(
          setUpdateEnrollmentEndDate(
            dayjs(new Date(currentYear, 5, 30)).format("YYYY-MM-DD")
          )
        );
        // * not sure which was latest but above line didn't give error. so keeping it as it is
        // dispatch(
        //   setUpdateEnrollmentStartDate(
        //     dayjs(new Date(currentYear - 1, 6, 1)).format("YYYY-MM-DD")
        //   )
        // );
        // dispatch(
        //   setUpdateEnrollmentEndDate(
        //     dayjs(new Date(currentYear, 5, 30)).format("YYYY-MM-DD")
        //   )
        // );
      } else {
        console.log("3:");
        // if currentMonth is between june and Dec of current year
        // we will assume membership is for current membership year.
        // unless there is an active membership; which is not the
        // case in createMember flow.
        setCurrentEnrollmentYearStart(new Date(currentYear, 6, 1)); // 1st July of the current year
        setCurrentEnrollmentYearEnd(new Date(currentYear + 1, 5, 30)); // 30th June of the next year
        dispatch(
          setUpdateEnrollmentStartDate(
            dayjs(new Date(currentYear, 6, 1)).format("YYYY-MM-DD")
          )
        );
        dispatch(
          setUpdateEnrollmentEndDate(
            dayjs(new Date(currentYear + 1, 5, 30)).format("YYYY-MM-DD")
          )
        );
      }
      console.log("4:");
      // callCreateMemberAPI();
      // console.log("redirect to /order/createorder");
      // navigate("/order/createorder", { replace: false });
    };

    initEnrollmentYearValue();

    // const getFirmDetailList = async () => {
    //   console.log("getFirmDetailList called");
    //   const response = await MemberServices.getFirmDetailList();
    //   console.log("FirmDetailList response...", response.data.data);
    //   if (response.data.data != null) {
    //     console.log("Success");
    //     setFirmList(response.data.data);
    //     // setPubFirmList(response.data.data);
    //     // dispatch(updateMemberList(response.data.data));
    //   } else {
    //   }
    // };

    // getFirmDetailList();
    console.log("useEffect - orderInfo", orderInfo);
    console.log("useEffect - currentMember", currentMember);
  }, []);

  useEffect(() => {
    console.log("useEffectCM-currentMember:", currentMember);
    console.log("useEffectCM - orderInfo", orderInfo);
    updateOrderDetail();
  }, [currentMember]);

  useEffect(() => {
    if (
      configurationList &&
      configurationList.MemberCode &&
      createMemberBody.Personal.MemberCodeId
    ) {
      const membercode = configurationList.MemberCode.find(
        (mc: any) => mc.Id === createMemberBody.Personal.MemberCodeId
      );
      if (membercode) {
        setOrderItem((prevOrderItem) => ({
          ...prevOrderItem,
          MemberCodeId: membercode.Id,
          MemberCode: membercode.MemberCode,
          MemberCodeDesc: membercode.Description,
          MemberCodeFee: membercode.Fee,
          OrderType: "Membership",
        }));
        setTotalAmount(membercode.Fee);
        setDueAmount(membercode.Fee);
        dispatch(
          storeUpdateOrder({
            key: "HasMembershipOrderItem",
            value: true,
          })
        );
      }
    }
  }, [createMemberBody.Personal.MemberCodeId]);

  useEffect(() => {
    if (selectedItems && selectedItems.length > 0) {
      // Only run if selectedItems has meaningful values
      console.log("selectedItems in useEffect:", selectedItems);
      orderItem &&
        console.log(
          "orderItem.CurrentYearSections:",
          orderItem.CurrentYearSections
        );
      dispatch(updateMember_Sections(selectedItems as number[]));

      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        CurrentYearSections: selectedItems,
      }));
      dispatch(
        storeUpdateOrder({
          key: "HasSectionOrderItem",
          value: true,
        })
      );
    }
  }, [selectedItems]);

  // This I didn't copy to createMemberPersonal. not sure about the need for this.
  // useEffect(() => {
  //   // Fetch the date from the Redux store and set it in the form
  //   setRefreshCount((prevCount) => prevCount + 1);
  //   setValue("MemberCodeId", createMemberBody.Personal.MemberCodeId, {
  //     shouldDirty: true,
  //   });

  //   setDateOfBirth(
  //     dayjs(createMemberBody.Personal.DateOfBirth).format("YYYY-MM-DD")
  //   );
  //   setValue(
  //     "DateOfBirth",
  //     dayjs(createMemberBody.Personal.DateOfBirth!, "YYYY-MM-DD").format(
  //       "YYYY-MM-DD"
  //     ),
  //     {
  //       shouldDirty: true,
  //     }
  //   );
  //   setAdmitDate(
  //     dayjs(createMemberBody.Personal.AdmitDate).format("YYYY-MM-DD")
  //   );
  //   dayjs(createMemberBody.Personal.AdmitDate).isValid() &&
  //     setValue(
  //       "AdmitDate",
  //       dayjs(createMemberBody.Personal.AdmitDate, "YYYY-MM-DD").format(
  //         "YYYY-MM-DD"
  //       ),
  //       {
  //         shouldDirty: true,
  //       }
  //     );

  //   setMediatorCertificationEndsOn(
  //     dayjs(createMemberBody.Personal.MediatorCertificationEndsOn).format(
  //       "YYYY-MM-DD"
  //     )
  //   );
  //   setValue(
  //     "MediatorCertificationEndsOn",
  //     dayjs(
  //       createMemberBody.Personal.MediatorCertificationEndsOn!,
  //       "YYYY-MM-DD"
  //     ).format("YYYY-MM-DD"),
  //     {
  //       shouldDirty: true,
  //     }
  //   );
  //   console.log("useEffect-createMemberBody changed");
  // }, [createMemberBody, setValue]);

  const checkRequiredFields = () => {
    let missingFields: string = "";
    if (createMemberBody.Personal.MemberCodeId == null) {
      missingFields = missingFields + " MemberCodeId, ";
    }
    if (createMemberBody.Personal.BarId == null) {
      missingFields = missingFields + "BarId, ";
    }
    if (
      createMemberBody.Personal.FirstName == null ||
      createMemberBody.Personal.FirstName == ""
    ) {
      missingFields = missingFields + "FirstName, ";
    }
    if (
      createMemberBody.Personal.LastName == null ||
      createMemberBody.Personal.LastName == ""
    ) {
      missingFields = missingFields + "LastName, ";
    }
    if (createMemberBody.Personal.AdmitDate == null) {
      missingFields = missingFields + "AdmitDate, ";
    }
    if (
      createMemberBody.PrimaryAddress.Email == null ||
      createMemberBody.PrimaryAddress.Email == ""
    ) {
      missingFields = missingFields + "Primary EmailID, ";
    }
    // if (createMemberBody.PublishedAddress.FirmName == null) {
    //   missingFields = missingFields + "Pub FirmName, ";
    // }

    if (missingFields !== "") {
      console.log("missingFields1:", missingFields);
      setShowAlertModal(true);
      setAlertTitle("Required Fields Missing");
      setAlertBody(missingFields);
      //alert(missingFields);
      return true;
    } else {
      console.log("No missing field");
      return false;
    }
  };

  const updatePaymentInfo = (e: any, date?: Date | null) => {
    switch (e.target.name) {
      case "PaymentMethod":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PaymentMethod: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "PaymentMethod",
            value: e.target.value,
          })
        );
        break;

      case "DatePaid":
        // const formattedDate = date ? dayjs(date) : null;
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   DatePaid: formattedDate,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "DatePaid",
            value: e.target.value,
          })
        );

        break;

      case "CheckNumber":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   CheckNo: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: e.target.value,
          })
        );
        break;

      case "AmountPaid":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AmountPaid: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "AmountPaid",
            value: e.target.value,
          })
        );
        break;

      case "LateFee":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   LateFee: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "LateFee",
            value: e.target.value,
          })
        );
        break;

      case "AuthCode":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AuthCode: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: e.target.value,
          })
        );
        break;

      case "PIcomments":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PIComments: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "comments",
            value: e.target.value,
          })
        );
        break;

      case "NoInvoiceFlag":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   NoInvoiceFlag: false,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "NoInvoice",
            value: e.target.checked,
          })
        );
        break;

      default:
        console.log("default");
        break;
    }
  };

  const onSubmitOrderInfo = async (e: any) => {
    // e.preventDefault();
    console.log("onSUBMIT:", orderInfo);
    const updatedOrders = orderInfo.Orders.map((order, index) =>
      index === 1 ? { ...order, ProratedDues: proratedDue } : order
    );

    const updatedOrderInfo = {
      ...orderInfo,
      Orders: updatedOrders
    };
    console.log("updatedOrderInfo:", updatedOrderInfo);
    const apiBody: any = updatedOrderInfo;
    try {
      const response = await OrderServices.createOrder(apiBody);
      console.log("ORDER response", response);
      if (response != null) {
        setCreateOrderModalOpen(false);
        console.log("ORDER response", response);
        const apiBody1: any = {
          orderId: response.data.data.insertId,
          memberId: orderInfo.MemberId,
          paymentStaus: 1, //invoice created
        };
        if (
          currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
          currentMember.MemberCodeId === 21 ||
          currentMember.MemberCodeId === 22
        ) {
          navigate("/member/findmember", { replace: true });
          return;
        } else {
          const response1 =
            await InvoiceServices.createMembershipOrderInvoiceSync(apiBody1);
          console.log("INVOICE response", response1.data.data);
          console.log("INVOICE URL", response1.data.data[0].InvoiceUrl);
          if (response1.data.data && response1.data.data.length > 0) {
            setinvoiceURL(response1.data.data[0].InvoiceUrl);
            setViewInvoiceModalOpen(true);
            console.log(
              "INVOICE response",
              response1.data.data.Invoices[0].InvoiceUrl
            );
          }
        }
        // alert("Order Created successfully");
        // dispatch(resetOrderParameters());  I am doing this in useEffect
        // navigate("/order", { replace: true });
        // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
        // dispatch(
        //   storeUpdateOrder({
        //     key: "TransactionAmount",
        //     value: 0,
        //   })
        // );
        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
        // navigate("/member/findmember", { replace: false });
        // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
        //  dispatch(screenChange("Events"));
      } else {
        // alert(response.data.errors);
        console.log("error");
      }
    } catch (error) {
      console.error("ORDER: Error creating order:", error);
    }
  };

  //not in use yet. Development in progress
  const onSubmitOrderInfoNew = async (e: any) => {
    // e.preventDefault();
    console.log("onSUBMIT:", orderInfo);

    const apiBody: any = orderInfo;
    try {
      const response = await OrderServices.createOrderTran(apiBody);
      console.log("ORDER response", response);
      if (response != null) {
        if (
          response.data?.result &&
          Array.isArray(response.data.result) &&
          response.data.result.length > 0
        ) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          setinvoiceURL(response.data.result[0].InvoiceUrl);
          setCreateOrderModalOpen(false);
          console.log("INVOICE response1", response.data.result[0].InvoiceUrl);
          // const apiBody1: any = {
          //   orderId: response.data.data.insertId,
          //   memberId: orderInfo.MemberId,
          //   paymentStaus: 1, //invoice created
          // };
          if (
            currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
            currentMember.MemberCodeId === 21 ||
            currentMember.MemberCodeId === 22
          ) {
            setShowAlertModal(true);
            setAlertTitle("SUCCESS");
            setAlertBody(
              "Order Created Successfully. No Invoice will send for members in NoInvoice membertag"
            );
            navigate("/member/findmember", { replace: true });
            return;
          } else {
            // // const response1 =
            // //   await InvoiceServices.createMembershipOrderInvoiceSync(apiBody1);
            // // console.log("INVOICE response", response1.data.data);
            // // console.log("INVOICE URL", response1.data.data[0].InvoiceUrl);
            // // if (response1.data.data && response1.data.data.length > 0) {
            // //   if (response.data.hasErrors) {
            // //     setShowAlertModal(true);
            // //     setAlertTitle("Database Error");
            // //     setAlertBody(response.data.errors[0].sqlMessage);
            // //     return;
            // //   }
            // setinvoiceURL(response.data.data[0].InvoiceUrl);
            setViewInvoiceModalOpen(true);
            //   console.log(
            //     "INVOICE response",
            //     response1.data.data.Invoices[0].InvoiceUrl
            //   );
            // }
          }
          // alert("Order Created successfully");
          // dispatch(resetOrderParameters());  I am doing this in useEffect
          // navigate("/order", { replace: true });
          // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
          // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
          // dispatch(
          //   storeUpdateOrder({
          //     key: "TransactionAmount",
          //     value: 0,
          //   })
          // );
          // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
          // navigate("/member/findmember", { replace: false });
          // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
          //  dispatch(screenChange("Events"));
        }
      } else {
        // alert(response.data.errors);
        console.log("error");
      }
    } catch (error) {
      console.error("ORDER: Error creating order:", error);
    }
  };

  const onSubmitPaymentInfo = async (e: any) => {
    // e.preventDefault();
    console.log("onSUBMIT:", orderInfo);
    setPaymentInfoModalOpen(false);
    const apiBody: any = orderInfo;
    const response = await OrderServices.createOrder(apiBody);
    // console.log("response", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      // alert("Order Created successfully");
      // dispatch(resetOrderParameters());  I am doing this in useEffect
      // navigate("/order", { replace: true });
      // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

      // dispatch(
      //   storeUpdateOrder({
      //     key: "TransactionAmount",
      //     value: 0,
      //   })
      // );

      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      navigate("/member/findmember", { replace: false });
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      //  dispatch(screenChange("Events"));
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };

  // const onSubmitCreateMember = () => {
  //   setCreateOrderModalOpen(true);
  //   updateOrderDetail();
  // };

  // ******* update order

  const updateOrderDetail = () => {
    if (currentMember.Id != null) {
      console.log("setCurrentMember:", currentMember);
      dispatch(
        storeUpdateOrder({
          key: "MemberId",
          value: currentMember?.Id,
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "OrderType",
          value: "Membership",
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "DatePaid",
          value: null,
        })
      );
      dispatch(
        storeAddOrderItem({
          key: "Orders",
          value: orderItem,
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "DueAmount",
          value: dueAmount,
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "TotalAmount",
          value: totalAmount,
        })
      );

      const currentDate = new Date(); // Get current date
      const currentYear = currentDate.getFullYear(); // Get current year
      const currentMonth = currentDate.getMonth(); // Get current month (0 for Jan, 11 for Dec)

      if (
        currentMonth >= 2 &&
        currentMonth < 6
        // currentEnrollmentYearEnd &&
        // currentYear === currentEnrollmentYearEnd.getFullYear()
      ) {
        dispatch(
          storeUpdateOrder({
            key: "enrollmentStartDate",
            value: dayjs(memberEnrollmentYearStart).format("YYYY-MM-DD"),
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "enrollmentEndDate",
            value: dayjs(memberEnrollmentYearEnd).format("YYYY-MM-DD"),
          })
        );
      }else{
        if (currentMonth < 2) {
          dispatch(
            storeUpdateOrder({
              key: "enrollmentStartDate",
              value: dayjs(new Date(currentYear - 1, 6, 1)).format("YYYY-MM-DD"),
            })
          );
          dispatch(
            storeUpdateOrder({
              key: "enrollmentEndDate",
              value: dayjs(new Date(currentYear, 5, 30)).format("YYYY-MM-DD"),
            })
          );
        } else {
          dispatch(
            storeUpdateOrder({
              key: "enrollmentStartDate",
              value: dayjs(new Date(currentYear, 6, 1)).format("YYYY-MM-DD"),
            })
          );
      }

        dispatch(
          storeUpdateOrder({
            //storeUpdateOrderItem({
            key: "enrollmentEndDate",
            value: dayjs(new Date(currentYear + 1, 5, 30)).format("YYYY-MM-DD"),
          })
        );
      }
    }
  };

  // ****** update order ends

  const getFirmDetailList = async () => {
    const response = await MemberServices.getFirmDetailList();
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      setFirmList(response.data.data);
    }
  };

  const rollbackCreatedFirms = async (firmIds: number[]) => {
    if (firmIds.length === 0) return;

    console.warn("⚠️ ROLLBACK NEEDED: Member creation failed but the following firms were created:");
    console.warn("Firm IDs:", firmIds);
    console.warn("These firms may need to be manually reviewed/deleted from the admin panel.");

    // TODO: Implement firm deletion API endpoint to enable automatic rollback
    // For now, firms remain in the database but are not associated with any member
  };

  const createFirmIfNeeded = async (
    firmName: string,
    addressData: any
  ): Promise<{ id: number | null; wasCreated: boolean }> => {
    if (!firmName || firmName.trim() === "") {
      return { id: null, wasCreated: false };
    }

    // Check if firm already exists (case-insensitive)
    const existingFirm = firmList.find(
      (firm: any) => firm.FirmName.trim().toLowerCase() === firmName.trim().toLowerCase()
    );

    if (existingFirm) {
      console.log("Firm already exists:", existingFirm.Id);
      return { id: existingFirm.Id, wasCreated: false };
    }

    // Create new firm using Primary Address data
    console.log("Creating new firm:", firmName);

    const newFirmData = {
      FirmName: firmName,
      Address1: addressData.Address1 || "No Current Address",
      Address2: addressData.Address2 || "",
      City: addressData.City || "No Current Address",
      State: addressData.State || "",
      Zipcode: addressData.Zipcode || "",
      County: addressData.County || "",
      FirmAdminEmailId: addressData.Email || ""
    };

    try {
      const firmResponse = await AdminUserService.addFirm(newFirmData);

      if (firmResponse.data.data != null) {
        if (firmResponse.data.hasErrors) {
          const errorMsg = firmResponse.data.errors[0].sqlMessage || firmResponse.data.errors[0];

          // If firm already exists, fetch it instead of failing
          if (typeof errorMsg === 'string' &&
              (errorMsg.includes("FirmName already taken") ||
               errorMsg.includes("already exists"))) {
            console.log("Firm already exists in database, fetching it...");

            // Fetch the updated firm list directly
            try {
              const response = await MemberServices.getFirmDetailList();
              if (response.data.data != null && !response.data.hasErrors) {
                const updatedFirmList = response.data.data;

                // Update state for next time
                setFirmList(updatedFirmList);

                // Find the firm in the fresh list
                const existingFirm = updatedFirmList.find(
                  (firm: any) => firm.FirmName.trim().toLowerCase() === firmName.trim().toLowerCase()
                );

                if (existingFirm) {
                  console.log("Found existing firm after refresh:", existingFirm.Id);
                  return { id: existingFirm.Id, wasCreated: false };
                }
              }
            } catch (refreshError) {
              console.error("Failed to refresh firm list:", refreshError);
            }
          }

          setShowAlertModal(true);
          setAlertTitle("Firm Creation Error");
          setAlertBody(errorMsg);
          return { id: null, wasCreated: false };
        }

        const firmId = firmResponse.data.data[0]?.Id || firmResponse.data.data.Id;
        console.log("New firm created with ID:", firmId);

        // Refresh firm list after creating a firm
        try {
          const response = await MemberServices.getFirmDetailList();
          if (response.data.data != null && !response.data.hasErrors) {
            setFirmList(response.data.data);
          }
        } catch (refreshError) {
          console.error("Failed to refresh firm list:", refreshError);
        }

        return { id: firmId, wasCreated: true };
      } else {
        setShowAlertModal(true);
        setAlertTitle("Firm Creation Error");
        setAlertBody("Failed to create firm");
        return { id: null, wasCreated: false };
      }
    } catch (error) {
      console.error("Error creating firm:", error);
      setShowAlertModal(true);
      setAlertTitle("Firm Creation Error");
      setAlertBody("An error occurred while creating the firm");
      return { id: null, wasCreated: false };
    }
  };

  const onSubmitCreateMember = async () => {
    if (checkRequiredFields()) {
      return;
    }
    console.log("setSelectedItems after", selectedItems);
    console.log("createMemberBody:", createMemberBody);
    console.log("TOTAL AMOUNT:", totalAmount);

    // ========== FIRM AUTO-CREATION LOGIC ==========

    const primaryFirmName = createMemberBody.PrimaryAddress.FirmName;
    const publishedFirmName = createMemberBody.PublishedAddress.FirmName;

    // Check if Primary and Published use the same firm (case-insensitive)
    const isSameFirm = primaryFirmName && publishedFirmName &&
                       primaryFirmName.trim().toLowerCase() === publishedFirmName.trim().toLowerCase();

    let primaryFirmId = createMemberBody.PrimaryAddress.Id || null;
    let publishedFirmId = createMemberBody.PublishedAddress.Id || null;
    const createdFirmIds: number[] = []; // Track newly created firms for rollback

    // Create Primary Address firm if needed
    if (primaryFirmName && primaryFirmName.trim() !== "") {
      const result = await createFirmIfNeeded(
        primaryFirmName,
        createMemberBody.PrimaryAddress
      );

      if (result.id === null && !createMemberBody.PrimaryAddress.Id) {
        // Firm creation failed and no existing firm ID
        return;
      }

      if (result.id !== null) {
        primaryFirmId = result.id;

        // Track if this is a newly created firm for rollback
        if (result.wasCreated) {
          createdFirmIds.push(result.id);
        }

        dispatch(updateMemberPrimaryAddressInfo({
          key: "Id",
          value: result.id,
        }));
      }
    }

    // Create Published Address firm if needed
    if (publishedFirmName && publishedFirmName.trim() !== "") {
      if (isSameFirm) {
        // Same firm name - use the same ID (create only ONE firm)
        publishedFirmId = primaryFirmId;

        dispatch(updateMemberPublishAddressInfo({
          key: "Id",
          value: primaryFirmId,
        }));
      } else {
        // Different firm - create separately
        const result = await createFirmIfNeeded(
          publishedFirmName,
          createMemberBody.PublishedAddress
        );

        if (result.id === null && !createMemberBody.PublishedAddress.Id) {
          // Rollback: Delete any firms we created
          await rollbackCreatedFirms(createdFirmIds);
          return;
        }

        if (result.id !== null) {
          publishedFirmId = result.id;

          // Track if this is a newly created firm for rollback
          if (result.wasCreated && !createdFirmIds.includes(result.id)) {
            createdFirmIds.push(result.id);
          }

          dispatch(updateMemberPublishAddressInfo({
            key: "Id",
            value: result.id,
          }));
        }
      }
    }

    // ========== END FIRM AUTO-CREATION LOGIC ==========

    // Create a modified version of createMemberBody with the firm IDs
    // Don't rely on Redux state updates - pass the IDs directly
    const memberDataToSubmit = {
      ...createMemberBody,
      PrimaryAddress: {
        ...createMemberBody.PrimaryAddress,
        Id: primaryFirmId || createMemberBody.PrimaryAddress.Id
      },
      PublishedAddress: {
        ...createMemberBody.PublishedAddress,
        Id: publishedFirmId || createMemberBody.PublishedAddress.Id
      }
    };

    console.log("memberDataToSubmit:", memberDataToSubmit);
    console.log("createdFirmIds:", createdFirmIds);

    const response = await MemberServices.createMember(memberDataToSubmit);
    console.log("response-createMember", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        // ROLLBACK: Member creation failed, delete any firms we created
        await rollbackCreatedFirms(createdFirmIds);

        setShowAlertModal(true);
        setAlertTitle("Database Error");

        // Customize error message for duplicate BarId
        const errorMsg = response.data.errors[0].sqlMessage || response.data.errors[0];
        console.log("Error message type:", typeof errorMsg);
        console.log("Error message value:", errorMsg);
        console.log("Full error object:", response.data.errors[0]);

        // Convert to string if it's an object
        const errorString = typeof errorMsg === 'string' ? errorMsg : JSON.stringify(errorMsg);

        if (errorString.includes("That Bar ID is already in use, please select another one.") ||
            errorString.includes("Member already available") ||
            errorString.toLowerCase().includes("barid")) {
          setAlertBody("That Bar ID is already in use, please select another one.");
        } else {
          setAlertBody(errorString);
        }
        return;
      }
      setShowAlertModal(true);
      setAlertTitle("SUCCESS");
      setAlertBody("Member Created Successfully");

      dispatch(resetCreateBody());
      // alert("Member Created successfully");
      dispatch(assignCurrentMember(response.data.data[0]));
      setCreateMemberSuccessFlag(true);
      setCurrentMember(response.data.data[0]);
      const currentDate = new Date(); // Get current date
      const currentYear = currentDate.getFullYear(); // Get current year
      const currentMonth = currentDate.getMonth(); // Get current month (0 for Jan, 11 for Dec)
      if(currentMonth > 2 && currentMonth < 6){
        setUpdateEnrollementYearModalOpen(true);
      }else{
        setCreateOrderModalOpen(true);
      }

      // navigate("/order/create-order", { replace: false });
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
    } else {
      alert(response.data.errors);
      console.log("error");
    }
    // console.log("redirect to /order/createorder");
    // navigate("/order/createorder", { replace: false });
  };

  // const computeTotalAmount = () => {
  //   let totalCostLocal: number = 0;
  //   Sections?.map((section: any) => {
  //     if (section.isSelected === true) {
  //       console.log("Selected Sections1:", section);
  //       if (section.Fee !== null) {
  //         totalCostLocal = totalCostLocal + section.Fee;
  //       }
  //     }
  //   });
  //   if (currentMember !== null && currentMember?.MemberCodeFee !== null) {
  //     totalCostLocal = totalCostLocal + currentMember.MemberCodeFee;
  //     console.log("totalCostLocal1:", totalCostLocal);
  //     setTotalAmount(totalCostLocal);
  //     return;
  //   }
  //   setTotalAmount(totalCostLocal);
  //   console.log("totalCostLocal2:", totalCostLocal);
  //   dispatch(
  //     storeUpdateOrder({
  //       key: "TransactionAmount",
  //       value: totalCostLocal,
  //     })
  //   );
  // };

  const toCamelCase = (str: string) => {
    if (!str) {
      return ""; // or handle it based on your use case
    }
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word: string, index: number) => {
        return index === 0 ? word.toUpperCase() : word.toLowerCase();
      })
      .replace(/\s+/g, "");
  };

  const color1 = "#2d6289";
  const color2 = "#008800";
  const colorError = "#FF0000";
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    switch (event.target.name) {
      case "State1":
        setState1(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId1: event.target.value,
        }));
        break;
      case "State2":
        setState2(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId2: event.target.value,
        }));
        break;
      case "State3":
        setState3(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId3: event.target.value,
        }));
        break;
      case "State4":
        setState4(event.target.value);
        setSelectedStates((prevState) => ({
          ...prevState,
          barId4: event.target.value,
        }));
        break;
      default:
        console.log("default case");
        break;
    }
  };

  // **** SECTIONS ****

  console.log("selectedItems: before", selectedItems);

  Sections &&
    Sections.map((section: ISection) => {
      const isChecked1 = (selectedFlag: number) => {
        return selectedFlag === section.Id;
      };

      if (createMemberBody.Sections.some(isChecked1)) {
        section.isSelected = true;
      } else {
        section.isSelected = false;
      }
    });

  console.log("selectedItems: after", selectedItems);

  const sectionHandleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    sectionItem: ISection
  ) => {
    console.log("sectionHandleChange", sectionItem);
    console.log("setSelectedItems before", selectedItems);
    if (event.target.checked) {
      setSelectedItems((selectedItems) => [
        ...selectedItems!,
        Number(event.target.id),
      ]);
      //setTotalAmount(totalAmount + sectionItem.Fee);
    } else {
      setSelectedItems((selectedItems) =>
        selectedItems!.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      //setTotalAmount(totalAmount - sectionItem.Fee);
    }
    console.log("setSelectedItems after", selectedItems);
  };

  // **** Member Tags ****

  const [selectedTags, setSelectedTags] = useState<
    (number | null)[] | undefined
  >(createMemberBody.Tags);

  const [tagRefreshCount, setTagRefreshCount] = useState<number>(0);
  useEffect(() => {
    setTagRefreshCount(tagRefreshCount + 1);
    console.log("selectedTags:", tagRefreshCount, "-", selectedTags);
  }, [selectedTags]);

  const [MemberTags, setMemberTags] = useState<IMemberTags[]>(
    configurationList.MemberTag
  );

  MemberTags &&
    MemberTags.map((memberTag: IMemberTags) => {
      const isChecked1 = (selectedFlag: number) => {
        return selectedFlag === memberTag.Id;
      };

      if (createMemberBody.Tags.some(isChecked1)) {
        memberTag.isSelected = true;
      } else {
        memberTag.isSelected = false;
      }
    });
  console.log("createMemberBody.Tags:", MemberTags);

  useEffect(() => {
    console.log("Tag updated");
    dispatch(updateMember_Tags(selectedTags as number[]));
  }, [selectedTags]);

  const memberTagHandleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    memberTags: IMemberTags
  ) => {
    if (event.target.checked) {
      setSelectedTags((selectedTags) => [
        ...selectedTags!,
        Number(event.target.id),
      ]);
    } else {
      setSelectedTags((selectedTags) =>
        selectedTags!.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
    }
  };

  {
    /****   OTHER STATES ****/
  }

  const [selectedStates, setSelectedStates] = useState<state>({
    barId1: 0,
    barId2: 0,
    barId3: 0,
    barId4: 0,
  });

  const [admitDate1, setAdmitDate1] = useState<Dayjs | null>(null);
  const [admitDate2, setAdmitDate2] = useState<Dayjs | null>(null);
  const [admitDate3, setAdmitDate3] = useState<Dayjs | null>(null);
  const [admitDate4, setAdmitDate4] = useState<Dayjs | null>(null);
  const [barId1, setBarId1] = useState("");
  const [barId2, setBarId2] = useState("");
  const [barId3, setBarId3] = useState("");
  const [barId4, setBarId4] = useState("");

  const [state1, setState1] = useState("");
  const [state2, setState2] = useState("");
  const [state3, setState3] = useState("");
  const [state4, setState4] = useState("");

  useEffect(() => {
    // for updating other state in store when changing date
    callDisptchOtherStates();
  }, [
    admitDate1,
    admitDate2,
    admitDate3,
    admitDate4,
    barId1,
    barId2,
    barId3,
    barId4,
    state1,
    state2,
    state3,
    state4,
  ]);
  const setBarId = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("barId event:", event.target.id, ":", event.target.value);
    switch (event.target.id) {
      case "OtherStatebarId1":
        setBarId1(event.target.value);
        break;
      case "OtherStatebarId2":
        setBarId2(event.target.value);
        break;
      case "OtherStatebarId3":
        setBarId3(event.target.value);
        break;
      case "OtherStatebarId4":
        setBarId4(event.target.value);
        break;
    }
    console.log("barIds:", selectedStates);
  };

  const callDisptchOtherStates = () => {
    let OtherStateBars = [];
    if (state1 != "") {
      OtherStateBars.push({
        BarName: state1,
        AdmitDate:
          admitDate1 != null
            ? dayjs(admitDate1, "YYYY-MM-DD").format("YYYY-MM-DD")
            : null,
        BarId: barId1,
      });
    }
    if (state2 != "") {
      OtherStateBars.push({
        BarName: state2,
        AdmitDate:
          admitDate2 != null
            ? dayjs(admitDate2, "YYYY-MM-DD").format("YYYY-MM-DD")
            : null,
        BarId: barId2,
      });
    }
    if (state3 != "") {
      OtherStateBars.push({
        BarName: state3,
        AdmitDate:
          admitDate3 != null
            ? dayjs(admitDate3, "YYYY-MM-DD").format("YYYY-MM-DD")
            : null,
        BarId: barId3,
      });
    }
    if (state4 != "") {
      OtherStateBars.push({
        BarName: state4,
        AdmitDate:
          admitDate4 != null
            ? dayjs(admitDate4, "YYYY-MM-DD").format("YYYY-MM-DD")
            : null,
        BarId: barId4,
      });
    }
    console.log("OtherStateBars:", OtherStateBars);

    dispatch(updateMember_OtherStateBar(OtherStateBars));
  };

  // Function to handle the change in checkbox selection
  const handleEnrollmentOptionChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const option = e.target.value;
    // setSelectedOption(option);

    const currentDate = new Date(); // Get current date
    const currentYear = currentDate.getFullYear(); // Get current year
    const currentMonth = currentDate.getMonth(); // Get current month (0 for Jan, 11 for Dec)

    // Update enrollment dates based on the selected option
    if (option === currentYear.toString()) {
      console.log("Current Year Selected");
      dispatch(
        storeUpdateOrder({
          key: "enrollmentStartDate",
          value: dayjs(new Date(currentYear - 1, 6, 1)).format("YYYY-MM-DD"),
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "enrollmentEndDate",
          value: dayjs(new Date(currentYear, 5, 30)).format("YYYY-MM-DD"),
        })
      );
      setProratedDue(0);
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        ProratedDues: 0,
      }));
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        IncludeNextYear: false,
      }));
      //setMemberEnrollmentYearStart(new Date(currentYear - 1, 6, 1)); // 1st July of the current year
      //setMemberEnrollmentYearEnd(new Date(currentYear, 5, 30)); // 30th June of the next year
      // don't know we need this. didn't see any error. so keeping it commented.
      // dispatch(
      //   setUpdateEnrollmentStartDate(
      //     dayjs(new Date(currentYear - 1, 6, 1)).format("YYYY-MM-DD")
      //   )
      // );
      // dispatch(
      //   setUpdateEnrollmentEndDate(
      //     dayjs(new Date(currentYear, 5, 30)).format("YYYY-MM-DD")
      //   )
      // );
    } else if (option === (currentYear + 1).toString()) {
      // Logic for updating enrollment year for next year
      console.log("Next Year Selected");
      dispatch(
        storeUpdateOrder({
          key: "enrollmentStartDate",
          value: dayjs(new Date(currentYear, 6, 1)).format("YYYY-MM-DD"),
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "enrollmentEndDate",
          value: dayjs(new Date(currentYear+1, 5, 30)).format("YYYY-MM-DD"),
        })
      );

      const dtNow = new Date();
      // Begin building the FY end date using today's date
      const dtFYEnds = new Date();
      // Set it to July 1 of the current year's date
      dtFYEnds.setFullYear(dtNow.getFullYear(), 6, 1); // Month is 0-indexed, so 6 is July
      // Compare it against July 1 of whatever year we're in
      const dtDiffFS = {
        days: Math.floor((dtFYEnds.getTime() - dtNow.getTime()) / (1000 * 3600 * 24)),
      };
			// Divide that by 365 and multiply by the dues cost of their current code
			const fProRatedDues = Math.round((dtDiffFS.days / 365) * currentMember.MemberCodeFee!!);
      setProratedDue(fProRatedDues);
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        ProratedDues: fProRatedDues,
      }));
      setOrderItem((prevOrderItem) => ({
        ...prevOrderItem,
        IncludeNextYear: true,
      }));
      //setMemberEnrollmentYearStart(new Date(currentYear, 6, 1)); // 1st July of the current year
      //setMemberEnrollmentYearEnd(new Date(currentYear + 1, 5, 30)); // 30th June of the next year
      // don't know we need this. its old code or new
      //setCurrentEnrollmentYearEnd(new Date(currentYear + 1, 5, 30)); // 30th June of the next year
      // dispatch(
      //   setUpdateEnrollmentStartDate(
      //     dayjs(new Date(currentYear, 6, 1)).format("YYYY-MM-DD")
      //   )
      // );
      // dispatch(
      //   setUpdateEnrollmentEndDate(
      //     dayjs(new Date(currentYear + 1, 5, 30)).format("YYYY-MM-DD")
      //   )
      // );
    }

  };

  const [textarea, setTextarea] = useState("");

  const commentsHandleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setTextarea(event.target.value);
    dispatch(updateMember_Comments(textarea));
  };

  const onSubmitViewMember = () => {
    navigate(routeConfig.MEMBER_DETAIL_URL, { replace: false });
  };

  const onSubmitEnrollmentYear = () => {
    dispatch(
      storeUpdateOrder({
        key: "proratedDue",
        value: proratedDue,
      })
    );
    dispatch(
      storeUpdateOrder({
        key: "DueAmount",
        value: (dueAmount + (proratedDue || 0)),
      })
    );
    dispatch(
      storeUpdateOrder({
        key: "TotalAmount",
        value: (totalAmount + (proratedDue || 0)),
      })
    );



    console.log(
      "EnrollmentYear:",
      memberEnrollmentYearStart,
      ":",
      memberEnrollmentYearEnd
    );
     new Promise(resolve => setTimeout(resolve, 100));

    setTimeout(() => {
      console.log(orderInfo);
      setCreateOrderModalOpen(true);
    }, 200);
    setUpdateEnrollementYearModalOpen(false);
  };

  return (
    <div className="dashboard-wrapper">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading" style={{ paddingTop: "1rem" }}>
          Create New Member
        </h1>
        {/* <PageLink onClick={openSavedSearchList}>Saved Search</PageLink> */}
      </div>
      <form
        className="form-wrapper"
        onSubmit={handleSubmitCM(onSubmitCreateMember)}
        noValidate
        name="memberForm"
        id="memberForm"
      >
        {/***  CREATE MEMBER PERSONAL ***/}

        <CreateMemberPersonal configurationList={configurationList} />

        {/****  CREATE  ADDRESS ****/}
        <CreateMemberAddress StateList={configurationList.StateList} />

        {/* <CMPublishedAddress
          FirmList={firmList}
          StateList={configurationList.StateList}
        /> */}

        {/****  CREATE PUBLISHED ADDRESS ****/}

        <></>

        {/****   SECTIONS ****/}
        <>
          <div className="section-box overflow-auto">
            <h3 className="section-heading">Sections</h3>
            <>
              <div className="sections-section">
                {Sections &&
                  Sections.map((section: ISection) =>
                    section.Status ? (
                      <MDEditSectionMultipleOptionItems
                        section={section}
                        onChangeFunction={sectionHandleChange}
                        isAdvanceOrder = {false}
                        isAddSectionFlow={false}
                      />
                    ) : null
                  )}
              </div>
            </>
          </div>
        </>

        {/****   MEMBER TAGS ****/}
        <>
          <div className="section-box  overflow-auto">
            <h3 className="section-heading">Member Tags</h3>
            <>
              <div className="sections-section">
                {MemberTags &&
                  MemberTags.map((memberTag: IMemberTags) =>
                    memberTag.Status ? (
                      <MDEditTagsMultipleOptionItems
                        memberTag={memberTag}
                        onChangeFunction={memberTagHandleChange}
                      />
                    ) : null
                  )}
              </div>
            </>
          </div>
        </>

        {/****   OTHER STATES ****/}
        <>
          <div className="section-box">
            <h3 className="section-heading">Other State Bar</h3>
            {/* <div> */}
            <form className="form-wrapper">
              <div className="otherstatebar-wrapper">
                <div className="otherstatebar-item">
                  <select
                    className="dropdown-control-small"
                    name="State1"
                    onChange={updateSelectBox}
                  >
                    <option value="">--States--</option>

                    {configurationList.StateList?.map((State: any) => {
                      const foundEntry1 = Object.entries(selectedStates).find(
                        ([key, value]) => value === State.StateName
                      );
                      let [foundKey, foundValue] = ["", ""];
                      if (foundEntry1) {
                        [foundKey, foundValue] = foundEntry1;
                      }
                      // console.log("foundEntry1:", foundKey, ":", foundValue);
                      return foundKey === "barId2" ||
                        foundKey === "barId3" ||
                        foundKey === "barId4" ? (
                        <></>
                      ) : (
                        <option key={State.Id} value={State.StateName}>
                          {State.StateName}
                        </option>
                      );
                    })}
                  </select>
                  <div
                    className="input-field-div-wrapper-small"
                    style={{ position: "relative" }}
                  >
                    <div
                      className="input-field-div-small"
                      style={{ width: "100%", height: "100%", padding: "0px" }}
                    >
                      <ThemeProvider theme={muiDatePickerColorTheme}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="datepicker-local"
                            label="Admit Date"
                            value={admitDate1}
                            onChange={(date) => date && setAdmitDate1(date)}
                          />
                        </LocalizationProvider>
                      </ThemeProvider>
                    </div>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="OtherStatebarId1"
                      name="OtherStatebarId1"
                      placeholder=""
                      autoComplete="off"
                      onChange={setBarId}
                    />
                    <Label
                      style={{ zIndex: "1" }}
                      className="form-label"
                      htmlFor="OtherStatebarId1"
                    >
                      Other State Bar ID
                    </Label>
                  </div>
                </div>
                <div className="otherstatebar-item">
                  <select
                    className="dropdown-control-small"
                    name="State2"
                    onChange={updateSelectBox}
                  >
                    <option value="">
                      {" "}
                      {/* disabled={true} */}
                      --States--
                    </option>
                    {configurationList.StateList?.map((State: any) => {
                      const foundEntry1 = Object.entries(selectedStates).find(
                        ([key, value]) => value === State.StateName
                      );
                      let [foundKey, foundValue] = ["", ""];
                      if (foundEntry1) {
                        [foundKey, foundValue] = foundEntry1;
                      }
                      // console.log("foundEntry1:", foundKey, ":", foundValue);
                      return foundKey === "barId1" ||
                        foundKey === "barId3" ||
                        foundKey === "barId4" ? (
                        <></>
                      ) : (
                        <option key={State.Id} value={State.StateName}>
                          {State.StateName}
                        </option>
                      );
                    })}
                  </select>
                  <div
                    className="input-field-div-wrapper-small"
                    style={{ position: "relative" }}
                  >
                    <div
                      className="input-field-div-small"
                      style={{ width: "100%", height: "100%", padding: "0px" }}
                    >
                      <ThemeProvider theme={muiDatePickerColorTheme}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="datepicker-local"
                            label="Admit Date"
                            value={admitDate2}
                            onChange={(date) => date && setAdmitDate2(date)}
                          />
                        </LocalizationProvider>
                      </ThemeProvider>
                    </div>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="OtherStatebarId2"
                      name="OtherStatebarId2"
                      placeholder=""
                      autoComplete="off"
                      onChange={setBarId}
                    />
                    <Label
                      style={{ zIndex: "1" }}
                      className="form-label"
                      htmlFor="OtherStatebarId2"
                    >
                      Other State Bar ID
                    </Label>
                  </div>
                </div>
                <div className="otherstatebar-item">
                  <select
                    className="dropdown-control-small"
                    name="State3"
                    onChange={updateSelectBox}
                  >
                    <option value="">
                      {" "}
                      {/* disabled={true} */}
                      --States--
                    </option>
                    {configurationList.StateList?.map((State: any) => {
                      const foundEntry1 = Object.entries(selectedStates).find(
                        ([key, value]) => value === State.StateName
                      );
                      let [foundKey, foundValue] = ["", ""];
                      if (foundEntry1) {
                        [foundKey, foundValue] = foundEntry1;
                      }
                      // console.log("foundEntry1:", foundKey, ":", foundValue);
                      return foundKey === "barId1" ||
                        foundKey === "barId2" ||
                        foundKey === "barId4" ? (
                        <></>
                      ) : (
                        <option key={State.Id} value={State.StateName}>
                          {State.StateName}
                        </option>
                      );
                    })}
                  </select>
                  {/* <div className="datepicker-small">
                <Label>Admit Date</Label>
                <DatePicker
                  className="datepicker-inputfield"
                  selected={admitDate3}
                  onChange={(date) => date && setAdmitDate1(date)}
                />
                <img className="calendaricon" src={CalendarImg} />

              </div> */}
                  <div
                    className="input-field-div-wrapper-small"
                    style={{ position: "relative" }}
                  >
                    <div
                      className="input-field-div-small"
                      style={{ width: "100%", height: "100%", padding: "0px" }}
                    >
                      <ThemeProvider theme={muiDatePickerColorTheme}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="datepicker-local"
                            label="Admit Date"
                            value={admitDate3}
                            onChange={(date) => date && setAdmitDate3(date)}
                          />
                        </LocalizationProvider>
                      </ThemeProvider>
                    </div>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="OtherStatebarId3"
                      name="OtherStatebarId3"
                      placeholder=""
                      autoComplete="off"
                      onChange={setBarId}
                    />
                    <Label
                      style={{ zIndex: "1" }}
                      className="form-label"
                      htmlFor="OtherStatebarId3"
                    >
                      Other State Bar ID
                    </Label>
                  </div>
                </div>

                <div className="otherstatebar-item">
                  <select
                    className="dropdown-control-small"
                    name="State4"
                    onChange={updateSelectBox}
                  >
                    <option value="">
                      {" "}
                      {/* disabled={true} */}
                      --States--
                    </option>
                    {configurationList.StateList?.map((State: any) => {
                      const foundEntry1 = Object.entries(selectedStates).find(
                        ([key, value]) => value === State.StateName
                      );
                      let [foundKey, foundValue] = ["", ""];
                      if (foundEntry1) {
                        [foundKey, foundValue] = foundEntry1;
                      }
                      // console.log("foundEntry1:", foundKey, ":", foundValue);
                      return foundKey === "barId1" ||
                        foundKey === "barId2" ||
                        foundKey === "barId3" ? (
                        <></>
                      ) : (
                        <option key={State.Id} value={State.StateName}>
                          {State.StateName}
                        </option>
                      );
                    })}
                  </select>
                  <div
                    className="input-field-div-wrapper-small"
                    style={{ position: "relative" }}
                  >
                    <div
                      className="input-field-div-small"
                      style={{ width: "100%", height: "100%", padding: "0px" }}
                    >
                      <ThemeProvider theme={muiDatePickerColorTheme}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="datepicker-local"
                            label="Admit Date"
                            value={admitDate4}
                            onChange={(date) => date && setAdmitDate4(date)}
                          />
                        </LocalizationProvider>
                      </ThemeProvider>
                    </div>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="OtherStatebarId4"
                      name="OtherStatebarId4"
                      placeholder=""
                      autoComplete="off"
                      onChange={setBarId}
                    />
                    <Label
                      style={{ zIndex: "1" }}
                      className="form-label"
                      htmlFor="OtherStatebarId4"
                    >
                      Other State Bar ID
                    </Label>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <TextField
            className="textarea"
            name="Comments"
            placeholder="Comments"
            value={textarea}
            multiline
            rows={5}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void =>
              commentsHandleChange(event)
            }
          />
        </>

        {/* <PrimaryAddress StateList={configurationList.StateList} /> */}
        {/* <PublishedAddress StateList={configurationList.StateList} />
      <Sections Sections={configurationList.MemberSection} />
      <MemberTags Tags={configurationList.MemberTag} /> */}
        {/* <OtherStateBar StateList={configurationList.StateList} /> */}
        <div
          className="button-wrapper"
          style={{ width: "100%", marginTop: "2rem", marginBottom: "100px" }}
        >
          <div className="submit-button-div">
            <Button type="submit">Create Member</Button>
          </div>
        </div>
      </form>
      <ReactModal
        isOpen={paymentInfoModalOpen}
        onRequestClose={() => setPaymentInfoModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Create Order</h1>
          <PageLink onClick={handleCancel}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmitPI(onSubmitPaymentInfo)}
          noValidate
        >
          <div className="input-field-div-wrapper">
            <Label>Order Date</Label>
            <input
              className="input-field-div input-disabled"
              id="OrderDate"
              name="OrderDate"
              value={dayjs().format("YYYY-MM-DD")}
              disabled={true}
            />
          </div>

          <div style={{ width: "28%", marginBottom: "1.8rem" }}>
            <Controller
              control={controlPI}
              name="DatePaid"
              // rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Date Paid"
                      value={value ? dayjs(value).toDate() : null}
                      onChange={(date: Date | null) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : null;
                        const syntheticEvent = {
                          target: {
                            name: "DatePaid",
                            value: date
                              ? dayjs(date).format("YYYY-MM-DD")
                              : null,
                          },
                        };
                        updatePaymentInfo(syntheticEvent, date);
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div
            className="horizontal-wrapper-spacebetween-center"
            style={{ width: "48%" }}
          >
            <>
              <label className="orderitem-header">Purchase Items</label>

              {Sections && (
                <>
                  <div className="horizontal-wrapper-rightaligned">
                    <label className="orderitem-label">
                      {Sections[0].SectionName}
                    </label>
                    <label
                      style={{
                        width: "10%",
                        paddingLeft: "0.5rem",
                      }}
                    >
                      :
                    </label>
                    <span className="orderitem-value">
                      {Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(Sections[0].Fee as number)}
                    </span>
                  </div>

                </>
              )}

              {/* <>
                {orderDetail.Orders.map((orderItem) =>
                  orderItem.EventType === "Membership" &&
                  orderItem.MemberCodeId !== null &&
                  orderItem.MemberCodeId !== 0 ? (
                    <>
                      <div className="horizontal-wrapper-rightaligned">
                        <label className="orderitem-label">
                          {toCamelCase(orderItem.MemberCodeDesc ?? "")}
                        </label>
                        <label
                          style={{
                            width: "10%",
                            paddingLeft: "0.5rem",
                          }}
                        >
                          :
                        </label>
                        <span className="orderitem-value">
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(orderItem.MemberCodeFee as number)}
                        </span>
                      </div>
                    </>
                  ) : (
                    <></>
                  )
                )}
              </> */}
              {/* <div
                className="order-totalorder"
                style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
              >
                <span className="orderitem-label"> TOTAL AMOUNT </span>
                <label style={{ width: "10%", paddingLeft: "0.5rem" }}>:</label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(transactionAmount as number)}
                </span>
              </div> */}
            </>
          </div>

          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <TextField
              className="textarea"
              id="PIcomments"
              name="PIcomments"
              placeholder=""
              multiline
              rows={3}
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            />
            <label className="form-label" htmlFor="PIcomments">
              Comments
            </label>
          </div>

          <div className="order-checkboxgroup">
            <input
              id="NoInvoiceFlag"
              name="NoInvoiceFlag"
              className="checkbox"
              type="checkbox"
              disabled={true}
              checked={
                currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
                currentMember.MemberCodeId === 21 ||
                currentMember.MemberCodeId === 22
                  ? true
                  : false
              }
              // onChange={(e) => updatePaymentInfo(e)}
            />
            <div>
              <span>
                No Invoice {currentMember.MemberCodeId}-
                {currentMember.MemberTags?.map((tag) => tag.Id)}
              </span>
            </div>
          </div>

          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                Create Order
              </Button>
            </div>
          </div>
        </form>
      </ReactModal>
      <ReactModal
        isOpen={createOrderModalOpen}
        onRequestClose={() => {
          handleCancel();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Create Order</h1>
          {/* <PageLink onClick={handleCancel}>Cancel</PageLink> */}
          <div className="secondary-button">
            <Button type="submit" onClick={handleCancel}>
              Close
            </Button>
            {/* </div> */}
          </div>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmitPI(onSubmitOrderInfo)}
          noValidate
        >
          <div className="input-field-div-wrapper">
            <Label>Order Date</Label>
            <input
              className="input-field-div input-disabled"
              id="OrderDate"
              name="OrderDate"
              value={dayjs().format("YYYY-MM-DD")}
              disabled={true}
            />
          </div>
          <div
            className="horizontal-wrapper-spacebetween-center"
            style={{ width: "48%" }}
          >
            <>
              <label className="orderitem-header">MemberShip Code</label>
              <div className="horizontal-wrapper-rightaligned">
                <label className="orderitem-label">
                  {orderItem.MemberCode}
                  {orderItem.MemberCode ? "-" : null}
                  {toCamelCase(orderItem.MemberCodeDesc ?? "")}
                </label>
                <label
                  style={{
                    width: "10%",
                    paddingLeft: "0.5rem",
                  }}
                >
                  :
                </label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(orderItem.MemberCodeFee as number)}
                </span>
              </div>
              {proratedDue !== null?
              <>
              <div className="horizontal-wrapper-rightaligned">
                <label className="orderitem-label">
                  Prorated Dues
                </label>
                <label
                  style={{
                    width: "10%",
                    paddingLeft: "0.5rem",
                  }}
                >
                  :
                </label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(proratedDue as number)}
                </span>
              </div>
              </> : <></>}
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                }}
              >
                <label className="orderitem-header">Sections</label>
                <label
                  style={{
                    marginTop: "0.4rem",
                  }}
                >
                  (suggested)
                </label>
              </div>
              {Sections &&
                Sections.map((sectionItems: ISection) =>
                  selectedItems.includes(sectionItems.Id) ? (
                    <>
                      <div className="horizontal-wrapper-leftaligned">
                        <label className="orderitem-label">
                          {sectionItems.SectionName}
                        </label>
                        {/* <label
                          style={{
                            width: "10%",
                            paddingLeft: "0.5rem",
                          }}
                        >
                          :
                        </label>
                        <span className="orderitem-value">
                          (
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(sectionItems.Fee as number)}
                          )
                        </span> */}
                      </div>
                    </>
                  ) : (
                    <></>
                  )
                )}
              <div
                className="order-totalorder"
                style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
              >
                <span className="orderitem-label"> TOTAL AMOUNT </span>
                <label style={{ width: "10%", paddingLeft: "0.5rem" }}>:</label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(orderInfo.TotalAmount as number)}
                </span>
              </div>
            </>
          </div>

          {currentMember.MemberCodeId === 21 ||
          currentMember.MemberCodeId === 22 ? (
            <div className="order-checkboxgroup">
              <input
                id="NoInvoiceFlag"
                name="NoInvoiceFlag"
                className="checkbox"
                type="checkbox"
                // onChange={(e) => updatePaymentInfo(e)}
                // disabled={true}
                readOnly={
                  currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
                  currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22
                    ? true
                    : false
                }
                checked={
                  currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
                  currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22
                    ? true
                    : false
                }
              />
              <div>
                <span>
                  No Invoice
                  {currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22 ? (
                    <span style={{ color: "red" }}>
                      {" "}
                      ({currentMember.Description})
                    </span>
                  ) : null}
                </span>
              </div>
            </div>
          ) : null}
          <div
            className="horizontal-wrapper-spaceevenly"
            style={{ marginTop: "2rem", marginBottom: "0.5rem" }}
          >
            {/* <div
              className="button-wrapper"
              style={{
                width: "100%",
                marginTop: "2rem",
                marginBottom: "100px",
              }}
            > */}
            {/* <div className="submit-button-div">
              <Button
                type="submit"
                onClick={onSubmitViewMember}
                style={{ background: "#fad478", color: "#000000" }}
              >
                View Member
              </Button>
            </div> */}
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </ReactModal>
      <ReactModal
        isOpen={viewInvoiceModalOpen}
        onRequestClose={() => {
          handleCancelViewInvoiceModal();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">View INVOICE</h1>
          <div className="d-flex" style={{ width: "30%" }}>
            <div className="secondary-button">
              <Button type="submit" onClick={handleCancelViewInvoiceModal}>
                Close
              </Button>
            </div>
            <div className="secondary-button">
              <Button type="submit" onClick={handleSendInvoice}>
                Email Invoice
              </Button>
              {/* </div> */}
            </div>
          </div>
          <div className="pdf-container">
            <iframe src={invoiceURL} allow="autoplay" loading="lazy"></iframe>
          </div>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={updateEnrollementYearModalOpen}
        onRequestClose={() => {
          handleCancelUpdateEnrollementYearModalOpen();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="vertical-wrapper">
          <h1 className="page-heading">Select Membership Year</h1>
          <div>
            <div
              className="checkbox-group"
              style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
            >
              <div
                style={{
                  fontWeight: "500",
                  paddingTop: "0.5rem",
                  paddingBottom: "0.5rem",
                }}
              >
                <input
                  type="radio"
                  name="enrollmentyear"
                  value={currentEnrollmentYearEnd!.getFullYear()} // current year
                  onChange={handleEnrollmentOptionChange}
                />{" "}
                {dayjs(currentEnrollmentYearStart!.toString()).format(
                  "DD-MMM-YYYY"
                )}
                {" to "}
                {dayjs(currentEnrollmentYearEnd!.toString()).format(
                  "DD-MMM-YYYY"
                )} {"( Current Year )"}
              </div>
              <div
                style={{
                  fontWeight: "500",
                  paddingTop: "0.5rem",
                  paddingBottom: "0.5rem",
                }}
              >
                <input
                  type="radio"
                  name="enrollmentyear"
                  value={currentEnrollmentYearEnd!.getFullYear() + 1} // next year
                  onChange={handleEnrollmentOptionChange}
                />{" "}
                {dayjs(currentEnrollmentYearStart!.toString()).add(1, "year").format(
                  "DD-MMM-YYYY"
                )}{" "}
                {" to "}
                {dayjs(currentEnrollmentYearEnd!)
                  .add(1, "year")
                  .format("DD-MMM-YYYY")} {"( Current & Next Year with Prorate Fees )"}
              </div>
            </div>
          </div>
          <div className="submit-button-div ">
            <Button type="submit" onClick={onSubmitEnrollmentYear}>
              Submit
            </Button>
          </div>
        </div>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CreateMemberPage;
